import React, { useState, useEffect} from "react";
import { BsDownload, BsCheck } from "react-icons/bs";

export default function Coupone(props){
    const [selRadio, setSelRadio] = useState(props.couponIssuHistSn?props.couponIssuHistSn:0);

    useEffect(() => {
        console.log(selRadio)
       if(selRadio){
            if(props.clickFn){
                props.clickFn(props.obj)
            }
       }
      }, [selRadio]);

    if (props.type==='down') {
        return(
            <div className="couponWr down">
                <div className="left">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
                <div className="right" onClick={(e)=>props.downClick(props.obj)}>
                    <div className="cpBtn">
                        <BsDownload />
                    </div>
                </div>
            </div>
        )
    } else if (props.type==='radio'){
        return (
            <div className="couponWr radio" onClick={(e)=>{setSelRadio(props.obj.couponIssuHistSn); }}>
                <div className="left">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
                <div className="right radioWr">
                    <input type="radio" id={props.obj.couponIssuHistSn} onChange={(e)=>{}} readOnly   checked={selRadio === props.obj.couponIssuHistSn} />
                    <label htmlFor={props.obj.couponIssuHistSn}></label>
                </div>
            </div>
        )
    } else if (props.type==='default'){
        return (
            <div className="couponWr">
                <div className="left">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
            </div>
        )
    } else if (props.type==='downFin'){
        return (
            <div className="couponWr downFin">
                <div className="left disa">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
                <div className="right">
                    <div className="cpBtn">
                        <BsCheck />
                    </div>
                </div>
            </div>
        )
    } else if (props.type==='used'){
        return (
            <div className="couponWr used">
                <div className="left disa">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
            </div>
        )
    } else if (props.type==='overDate'){
        return (
            <div className="couponWr overDate">
                <div className="left disa">
                    <h3 className="discount">{props.discount}</h3>
                    <p className="name">{props.name}</p>
                    <p className="info">{props.info}</p>
                    <p className="date">{props.date}</p>
                </div>
            </div>
        )
    }
    
}